// @flow

import React from "react";
import { localize } from "redux-i18n";
import { formatDateTime } from "@transformers/date";
import { GSGrid } from "@components";
import type { SharedPresentations } from "@modules/reporting/reducer/reports/mi-reports/types";
import { compose } from "redux";
import { connect } from "react-redux";
import actionCreators from "@modules/reporting/actionCreator";

type OwnProps = $Exact<{
  className?: string | null,
  data: SharedPresentations[],
  clientId: number,
}>;

type PropsFromDispatch = $Exact<{
  downloadPresentationFile: typeof actionCreators.DownloadMiReportsPresentation,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class SharedMiPresentations extends React.Component<Props> {
  get columns() {
    return [
      {
        name: this.props.t("ID"),
        key: "id",
      },
      {
        key: "dateShared",
        name: this.props.t("DATE_SHARED"),
        renderCell: ({ row }: Object) => formatDateTime(row.sharedAt),
      },
      {
        name: this.props.t("SHARED_BY"),
        key: "sharedBy",
        renderCell: ({ row }: Object) => `${row.sharedBy?.firstName} ${row.sharedBy?.lastName}`,
      },
      {
        name: this.props.t("PRESENTATION_NAME"),
        key: "name",
      },
      {
        name: this.props.t("DOWNLOAD"),
        width: 100,
        renderCell: ({ row }: Object) =>
          row.presentationFile && !row.presentationFile.isArchived ? (
            <span
              className="material-icons font-size-26 pointer"
              onClick={this.downloadPresentation(row.id, row.presentationFile)}
            >
              file_download
            </span>
          ) : (
            <span className="material-icons text-color-grey">file_download</span>
          ),
        key: "downloadUrl",
        align: "center",
      },
      {
        key: "dateDownloaded",
        name: this.props.t("DOWNLOAD_DATE"),
        renderCell: ({ row }: Object) =>
          row.downloadedAt ? formatDateTime(row.downloadedAt) : <span>{this.props.t("N/A")}</span>,
      },
    ];
  }

  downloadPresentation = (reportId: number, file: Object) => (e: Object) => {
    e.preventDefault();
    const { clientId } = this.props;
    const { id, name } = file;

    if (reportId && clientId && id && name) {
      this.props.downloadPresentationFile({
        clientId,
        reportId,
        fileId: id,
        fileName: name,
      });
    }
  };

  render() {
    return (
      <div className="formatted-grid-wrapper w-100 p-0">
        <GSGrid
          rows={this.props.data}
          columns={this.columns}
          noResultsText={this.props.t("NO_PRESENTATIONS_TEXT")}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  downloadPresentationFile: actionCreators.DownloadMiReportsPresentation,
};

export default compose(localize(), connect(undefined, mapDispatchToProps))(SharedMiPresentations);
